import { getField, updateField } from 'vuex-map-fields'

export const state = () => ({
  all: []
})

export const getters = {
  workspaces (state) {
    return state.all
  },
  active (state, getters, rootState) {
    return state.all?.find(
      (w) => w.id === rootState.selectedAssistant?.workspaceActiveId
    )
  },
  getField
}

export const actions = {
  async populate ({ commit, rootGetters }) {
    const result = await this._vm.$axios.get(`/workspaces`)
    const workspaces = result.data.data.map((workspace) => workspace._source)
    commit('setWorkspaces', workspaces)
  }
}

export const mutations = {
  setWorkspaces (state, workspaces) {
    state.all = workspaces
  },
  updateField
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
